import useAuth from '../../../hooks/useAuth';
import { Fragment, useState, useEffect, useCallback } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Formik, Form, Field } from 'formik';
import { useLocation } from 'react-router-dom';
import { useGetPartnersMutation } from '../../../redux/features/user/partnersApiSlice';
import {
  useGetAllUsersMutation,
  useChangeUserPartnerMutation,
} from '../../../redux/features/user/usersApiSlice';

const ChangeUserPartner = () => {
  let [isOpen, setIsOpen] = useState(false);
  const [partnersList, setPartnersList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [getPartners] = useGetPartnersMutation();
  const [getAllUsers] = useGetAllUsersMutation();
  const [changeUserPartner] = useChangeUserPartnerMutation();

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  const handleSubmit = async (formData) => {
    try {
      console.log(formData, 'formdata');
      const result = await changeUserPartner(formData).unwrap();
      return result;
    } catch (error) {
      console.log(error);
    }
  };

  const modalInitialValues = {
    userId: '',
    partnerId: '',
  };
  const location = useLocation();
  const path = location.pathname.split('/')[1];

  useEffect(() => {
    fetchPartners();
  }, []);

  const fetchPartners = useCallback(async () => {
    const result = await getPartners(path).unwrap();
    setPartnersList(result);
  });

  useEffect(() => {
    const fetchUsers = async () => {
      const result = await getAllUsers().unwrap();
      setUsersList(result);
    };
    fetchUsers();
  }, []);

  return (
    <div>
      {' '}
      <button
        onClick={openModal}
        type='button'
        className='bg-[#f8d229] hover:bg-green-700  w-64 rounded-lg  text-white py-2 text-center items-center'
      >
        Change User Partner
      </button>
      <Transition
        appear
        show={isOpen}
        //   show={modalDeletePartnerOpen}
        as={Fragment}
      >
        <Dialog as='div' className='relative z-10' onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-black bg-opacity-25' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className='w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all'>
                  <Dialog.Title
                    as='h3'
                    className='text-lg font-medium leading-6 mb-2 text-gray-900'
                  >
                    Change User Partner
                  </Dialog.Title>
                  <div>
                    {/* <select className=' border border-[#B7C6D7] rounded-md  w-64 px-2 py-2 text-black placeholder-[#B7C6D7]'>
                      <option disabled selected value=''>
                        -
                      </option>
                      {partnersList.map((partner) => (
                        <option value={partner.id}>{partner.name}</option>
                      ))}
                    </select> */}
                    <Formik
                      enableReinitialize={true}
                      initialValues={modalInitialValues}
                      onSubmit={handleSubmit}
                    >
                      <Form className='flex justify-between'>
                        <Field
                          className=' border border-[#B7C6D7] rounded-md  w-64 px-2 py-2 text-black placeholder-[#B7C6D7]'
                          as='select'
                          name='userId'
                          //   onChange={(e) => setUserId(e.target.value)}
                        >
                          <option disabled selected value=''>
                            -
                          </option>
                          {usersList.map((user) => (
                            <option value={user.id}>
                              {user.username}
                              {!user.partnerId && '*'}
                            </option>
                          ))}
                        </Field>
                        <Field
                          className=' border border-[#B7C6D7] rounded-md  w-64 px-2 py-2 text-black placeholder-[#B7C6D7]'
                          name='partnerId'
                          as='select'
                        >
                          <option disabled selected value=''>
                            -
                          </option>
                          {partnersList.map((partner) => (
                            <option value={partner.id}>{partner.name}</option>
                          ))}
                        </Field>
                        <button
                          type='submit'
                          className='bg-[#5dd83e] hover:bg-green-700 px-2 rounded-lg  text-white py-2 text-center items-center'
                        >
                          Change
                        </button>
                      </Form>
                    </Formik>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default ChangeUserPartner;
